import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const run = (
  state: number | null = null,
  action: NotebookAction
): number | null => {
  switch (action.type) {
    case NotebookActionKey.SET_RUN:
      return action.payload.id;
    // When worker is stopped / restarted, this should get cleared.
    case NotebookActionKey.STOP_RUN:
      return null;
    default:
      return state;
  }
};
